import React from 'react'

const AppSettings = () => {
  return (
    <div></div>
  )
}

export default AppSettings